// extracted by mini-css-extract-plugin
module.exports = {"profileWrapper":"styles_profileWrapper__y8gs8","userImageWrapper":"styles_userImageWrapper__fa_Q2"};